import React from 'react'
import type { FC } from 'react'
import { User } from 'lucide-react'
import { Badge } from './badge'

import type { Post } from '@payload-types'

interface PostAuthorsProps {
  authors: Post['populatedAuthors']
}

export const PostAuthors: FC<PostAuthorsProps> = ({ authors }) => {
  if (!authors || authors.length === 0) return null

  return (
    <div className="flex flex-wrap gap-2">
      {authors.map((author, index) => (
        <Badge
          key={index}
          href={`/yazarlar/${author.id}`}
          title={author.name || ''}
          variant="primary"
          icon={<User className="h-3 w-3" />}
        />
      ))}
    </div>
  )
}
